import { UnauthorizedService, APIServiceLogout } from './ApiService';

export const login = payload => UnauthorizedService.post('auth/login', { ...payload });

export const register = payload => UnauthorizedService.post('auth/users', { ...payload });

export const logOutToken = payload => APIServiceLogout.post('auth/logout', { ...payload });
